import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import MyAppBar from '../../components/MyAppBar';
import { Container, Paper, CircularProgress } from '@mui/material';
import ContinuedApplicantTable from '../../components/ContinuedApplicantTable';

const styles = {
  container: {
    padding: 1,
  },
  paper: {
    margin: 2,
    padding: 4,
  },
  indent: {
    paddingLeft: 5,
  },
};

const MONTHS = [
  'JANUARY',
  'FEBRUARY',
  'MARCH',
  'APRIL',
  'MAY',
  'JUNE',
  'JULY',
  'AUGUST',
  'SEPTEMBER',
  'OCTOBER',
  'NOVEMBER',
  'DECEMBER',
  'JANUARY',
];

function getNextMonth(month) {
  console.log(`month: ${month}`);
  return MONTHS[parseInt(month)];
}

function sortFunc(a, b) {
  if (a.PERMITTEE > b.PERMITTEE) return 1;
  if (a.PERMITTEE < b.PERMITTEE) return -1;
  return 0;
}

export default function D(props) {
  const { yearmonth } = useParams();
  const [year, month] = yearmonth.split('-');
  const [loading, setLoading] = useState(false);
  const [cases, setCases] = useState([]);

  useEffect(() => {
    const getCases = async () => {
      setLoading(true);
      const { apiUrl } = window['config'];
      const response = await fetch(
        `${apiUrl}/appendix/continuedApplicants/${year}/${month}`
      );
      const casesResult = await response.json();
      casesResult.sort(sortFunc);
      setCases(casesResult);
      setLoading(false);
    };
    getCases();
  }, [month, year]);

  return (
    <React.Fragment>
      <MyAppBar title='Appendix D - Continued Applicants' />
      <Container sx={styles.container}>
        <Paper sx={styles.paper}>
          <p>
            {`The following applicants have been continued to the hearing in ${getNextMonth(
              month
            )}.`}
          </p>
          {loading ? (
            <CircularProgress />
          ) : (
            <ContinuedApplicantTable permits={cases} />
          )}
        </Paper>
      </Container>
    </React.Fragment>
  );
}
